import {FC} from 'react'
import GIcon from '../../../Icon/GIcon'
import {FormError} from '../FormError'
import {FormTextProps} from './Text.types'

export const FormText: FC<FormTextProps> = ({
  className,
  inputClassName,
  error,
  touched,
  type = 'text',
  prependIcon,
  prependInnerIcon,
  appendIcon,
  appendInnerIcon,
  prependClassname,
  prependInnerClassname,
  appendClassname,
  appendInnerClassname,
  clickPrependIcon,
  clickPrependInnerIcon,
  clickAppendIcon,
  clickAppendInnerIcon,
  prependNode,
  appendNode,
  prefix,
  suffix,
  ...rest
}) => {
  const hasError = touched && error

  const inputClasses = [
    inputClassName,
    hasError
      ? 'border border-solid border-danger focus:border focus:border-solid focus:border-danger'
      : '',
    prependInnerIcon || prefix ? 'pl-14' : '',
    appendInnerIcon || suffix ? 'pr-14' : '',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={className}>
      <div className="relative flex items-center">
        {prependNode ? <div className="ml-2">{prependNode}</div> : null}

        {prependIcon ? (
          <GIcon
            icon={prependIcon}
            className={`cursor-pointer mr-2 w-5 h-5 ${prependClassname || ''}`}
            onClick={clickPrependIcon}
          />
        ) : null}

        <div className="relative flex items-center flex-grow">
          {prependInnerIcon ? (
            <GIcon
              icon={prependInnerIcon}
              className={`cursor-pointer absolute left-4 w-5 h-5 ${prependInnerClassname || ''}`}
              onClick={clickPrependInnerIcon}
            />
          ) : null}

          {prefix ? (
            <div className="absolute left-4 text-fs-9 font-medium">
              {prefix}
            </div>
          ) : null}

          <input type={type} className={inputClasses} {...rest} />

          {suffix ? (
            <div className="absolute right-4 text-fs-9 font-medium">
              {suffix}
            </div>
          ) : null}

          {appendInnerIcon ? (
            <GIcon
              icon={appendInnerIcon}
              className={`cursor-pointer absolute right-4 w-5 h-5 ${appendInnerClassname || ''}`}
              onClick={clickAppendInnerIcon}
            />
          ) : null}
        </div>

        {appendIcon ? (
          <GIcon
            icon={appendIcon}
            className={`cursor-pointer ml-2 w-5 h-5 ${appendClassname || ''}`}
            onClick={clickAppendIcon}
          />
        ) : null}

        {appendNode ? <div className="ml-2">{appendNode}</div> : null}
      </div>

      {hasError ? <FormError>{error}</FormError> : null}
    </div>
  )
}